module.exports = __webpack_public_path__ + "img/NHaasGroteskTXPro-55Rg.c968235.svg";